/**
 * @file
 * This simple component preloads an image, and fades it in once loaded. It is
 * styled with `width: 100%; height: 100%`, so size your image with a parent
 * component or override the css of `.preloaded-image`.
 *
 * @param {str} url - the source of the image
 * @param {str} [fallbackUrl] - the image to show if there's a problem
 */

import React from "react";
import CssTransitionGroup from "react-transition-group/CSSTransitionGroup";
import PropTypes from "prop-types";

import Context from "shared/util/Context";
import useImageLoader from "shared/hooks/useImageLoader";

import "./PreloadedImage.scss";

const PreloadedImage = ({ url, fallbackUrl }) => {
	const src = useImageLoader(url, fallbackUrl);

	return (
		<div className="preloaded-image">
			<CssTransitionGroup
				transitionName="preloaded-image-content"
				transitionAppear
				transitionEnterTimeout={500}
				transitionAppearTimeout={500}
				transitionLeaveTimeout={500}
			>
				{src &&
					<div
						className="preloaded-image-content"
						style={{ backgroundImage: `url(${src})` }}
					/>
				}
			</CssTransitionGroup>
		</div>
	);
};

PreloadedImage.propTypes = {
	url: PropTypes.string.isRequired,
	fallbackUrl: PropTypes.string,
};

PreloadedImage.defaultProps = {
	fallbackUrl: `${Context.get("cssImagePath")}media/img/user/placeholder_2013/pq_225.png`,
};

export default PreloadedImage;



// WEBPACK FOOTER //
// ./src/shared/components/PreloadedImage.jsx